/**
 * @flow
 * @relayHash ede0a1b5b16db893e20f511d226b32e3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type GeneratePOsForLowStockMutationVariables = {||};
export type GeneratePOsForLowStockMutationResponse = {|
  +generatePOsForLowStock: {|
    +purchaseOrders: $ReadOnlyArray<{|
      +node: {|
        +id: string,
        +poNumber: string,
        +vendor: ?{|
          +id: string,
          +name: string,
        |},
        +status: POStatus,
        +totalAmount: number,
      |}
    |}>,
    +itemsProcessed: number,
  |}
|};
export type GeneratePOsForLowStockMutation = {|
  variables: GeneratePOsForLowStockMutationVariables,
  response: GeneratePOsForLowStockMutationResponse,
|};
*/


/*
mutation GeneratePOsForLowStockMutation {
  generatePOsForLowStock {
    purchaseOrders {
      node {
        id
        poNumber
        vendor {
          id
          name
        }
        status
        totalAmount
      }
    }
    itemsProcessed
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generatePOsForLowStock",
    "storageKey": null,
    "args": null,
    "concreteType": "GeneratePOsForLowStockPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "purchaseOrders",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrderEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchaseOrder",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "poNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Vendor",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalAmount",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "itemsProcessed",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GeneratePOsForLowStockMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GeneratePOsForLowStockMutation",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GeneratePOsForLowStockMutation",
    "id": null,
    "text": "mutation GeneratePOsForLowStockMutation {\n  generatePOsForLowStock {\n    purchaseOrders {\n      node {\n        id\n        poNumber\n        vendor {\n          id\n          name\n        }\n        status\n        totalAmount\n      }\n    }\n    itemsProcessed\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c16eb682a3c45bf28144cee8f095d5a1';
module.exports = node;
